
 
 



<div class="contents tab_content" id="content1" data-tab="1">
 
    <div class="toggle_view" >
        <mat-button-toggle-group
      name="fontStyle"
      aria-label="Font Style"
      color="accent"
      class="m-3"
      
      >
      <mat-button-toggle value="list" color="accent" (click)="onList()"
        ><mat-icon class="example-tab-icon"
          >list</mat-icon
        ></mat-button-toggle
      >
      <mat-button-toggle value="grid" (click)="onGrid()"
        ><mat-icon class="example-tab-icon"
          >view_module</mat-icon
        ></mat-button-toggle
      >
      </mat-button-toggle-group>
      </div>
   
  <form [formGroup]="impactedcommunityForm">

  <div class="impacted_communities"  >
    <div class="form_input">
      <h2 class="heading">Impacted Community</h2>
     
      <div class="form">
        <div class="input">
          <label for="">State</label>
          <mat-select name="" class="default_input reference-form" formControlName="ImpactedStateId" (selectionChange)="onFilterLga($event.value)">
            <mat-option value="">Select item</mat-option>
            <mat-option *ngFor="let stateitem of states" [value]="stateitem.id">{{stateitem.StateName}}</mat-option>

          </mat-select>
        </div>

        <div class="input">
          <label for="">LGA</label>
          <mat-select name="" class="default_input reference-form" formControlName="ImpactedLGAId" (selectionChange)="onFilterCommunity($event.value)">
            <mat-option value="">Select item</mat-option>
            <mat-option *ngFor="let lgaitem of filterLgas" [value]="lgaitem.id">{{lgaitem.LgaName}}</mat-option>

          </mat-select>
        </div>

        <div class="input">
          <label for="">Community</label>
          <mat-select name="" class="default_input reference-form" formControlName="ImpactedCommunityId">
            <mat-option value="">Select item</mat-option>
            <mat-option *ngFor="let commitem of filterCommunities" [value]="commitem.id">{{commitem.CommunityName}}</mat-option>

          </mat-select>
        </div>

        <div class="input">
          <label for="">Remarks</label>
          <textarea class="default_input" id="" cols="20" rows="5" formControlName="Remarks"></textarea>
        </div>
      </div>
      <div class="btn_holder" style="display: flex; justify-content: center;">
        <button
          class="default_primary-button"
          (click)="addImpactedCommunity(impactedcommunityForm.value)"
          type="submit"
        >
          <ng-container *ngIf="selectedIndex === null">
            Add &rarr;
          </ng-container>
          <ng-container *ngIf="selectedIndex !== null">
            Update &rarr;
          </ng-container>
        </button>

        <div class="refresh">
        <button mat-button (click)="onClearForm()">
           <em class="material-icons">
            settings_backup_restore
            </em> Reset</button>
        </div>
      </div>

     
    </div>

    <div class="enteries" *ngIf="listView">
      <div class="impacted_communities-table">
        <div class="the_head">
          <span class="head_item">S/N</span>
          <span class="head_item">State</span>
          <span class="head_item">Lga</span>
          <span class="head_item">Community</span>
          <span class="head_item">Remark</span>
          <span class="head_item">Action</span>
        </div>


        <div class="the_row"  *ngFor="let impactcommitem of impactcommunityFormArray.get('ImpactedCommunitys')['controls']; index as i"
        (click)="onEdit(i, impactcommitem.value)" style="cursor: pointer;"
        matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over">
          <span class="row_data">{{i + 1}}</span>
          <span class="row_data">{{getStateName(impactcommitem.value.ImpactedStateId)}}</span>
          <span class="row_data">{{getLgaName(impactcommitem.value.ImpactedLGAId)}}</span>
          <span class="row_data">{{getCommunityName(impactcommitem.value.ImpactedCommunityId)}}</span>
          <span class="row_data">{{impactcommitem.value.Remarks}}</span>
          <!-- <span class="row_data"><em class="ti-more-alt"></em> </span> -->
          <span class="row_data" (click)="$event.stopImmediatePropagation()">
            <button
            class="delete_icon trash"
  
            (click)="deleteImpactedCommunity(i, impactcommitem.value)">
            <em class="ti-trash"> </em> </button>
          </span>
        </div>
       
      
      </div>
      <div class="btn_holder" *ngIf="listView" style="text-align:center">
          <button class="default_primary-button" (click)="onSubmit()">Submit</button>
        </div>
    </div>
   
      
      
      <div class="entry_values"  *ngIf="gridView">
          <div class="entry" *ngFor="let impactcommitem of impactcommunityFormArray.get('ImpactedCommunitys')['controls']; index as i"
          
          (click)="onEdit(i, impactcommitem.value)" style="cursor: pointer;"
          matTooltip="Click to edit"
            aria-label="Button that displays a tooltip when focused or hovered over"
          >
            <h1 class="section_name">
            
              <p class="other_item"> State Name: <span class="row_data">{{getStateName(impactcommitem.value.ImpactedStateId)}}</span>
              <em class="ti-trash"  (click)="deleteImpactedCommunity(i, impactcommitem.value)"></em> 
              <em class="ti-pencil-o"  (click)="onEdit(i, impactcommitem.value)"></em> 
            </p>
            </h1>
      
            <div class="location">
              <!-- <p class="other_item">State Name: <span class="file_name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="StateName"></span></p>
              <p class="other_item">Lga Name: <span class="location_name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="LgaName"></span></p>
              <p class="other_item">Community Name: <span class="location_name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="CommunityName"></span></p>
              <p class="other_item">Remarks: <span class="location_name"><input type="text" style="border: none" name="faculty" id="Faculty" class="input" formControlName="Remarks"></span></p>
              -->
              <p class="other_item"> State Name: <span class="row_data">{{getStateName(impactcommitem.value.ImpactedStateId)}}</span></p>
                <p class="other_item"> Lga Name: <span class="row_data">{{getLgaName(impactcommitem.value.ImpactedLGAId)}}</span></p>
                  <p class="other_item"> Community Name: <span class="row_data">{{getCommunityName(impactcommitem.value.ImpactedCommunityId)}}</span></p>
                    <p class="other_item"> Remarks: <span class="row_data">{{impactcommitem.value.Remarks}}</span></p>
            </div>
          </div>
          <div class="btn_holder">
              <button  class="default_primary-button"  (click)="onSubmit()" >
         
                  Save  &rarr;
               
              </button>
           </div>
        </div>
  </div>

</form>
</div>
